import { useState } from 'react'

/** Downloads the SillyTavern-compatible JSON lorebook. The file lives in the
 *  web app's public folder (apps/web/public/system-404-exit-not-found.json)
 *  and is regenerated by `bun run build-lorebook.ts` at the repo root, which
 *  mirrors the built JSON into public/ on every run. */
const JSON_URL = '/system-404-exit-not-found.json'
const DOWNLOAD_NAME = 'system-404-exit-not-found.json'

export function DownloadButton({ className = '' }: { className?: string }) {
  const [state, setState] = useState<'idle' | 'loading' | 'error'>('idle')

  const download = async () => {
    if (state === 'loading') return
    setState('loading')
    try {
      const res = await fetch(JSON_URL)
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const text = await res.text()
      const blob = new Blob([text], { type: 'application/json;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = DOWNLOAD_NAME
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(url)
      setState('idle')
    } catch {
      setState('error')
      // Reset after a moment so the user can retry
      setTimeout(() => setState('idle'), 2500)
    }
  }

  const label = state === 'loading' ? 'Preparing…' : state === 'error' ? 'Failed, retry' : 'JSON'

  return (
    <button
      type="button"
      onClick={download}
      title="Download the SillyTavern-compatible JSON lorebook"
      className={`rounded-full border border-signal/40 px-4 py-1.5 text-sm text-signal transition hover:border-signal/60 hover:bg-signal/10 hover:text-white ${className}`}
    >
      {label}
    </button>
  )
}
